module.exports = __webpack_public_path__ + "img/Rel.Manager@2x.f0bd2da8.png";